export class ShareHistory {
    flagsSharedTypes = ["donwload", "email", "link", "whatsapp"];
    constructor({ Report } = {}) {
        this.Report = Report;
    }

    async setReportShareHistory(shareType, reportId, userId) {
        if (!this.flagsSharedTypes.includes(shareType))
            throw new Error(
                `Flag de histórico de compartilhamento inválido, flags válidos são: [${this.flagsSharedTypes.join(
                    " | "
                )}]`
            );

        const { response } = await this.Report.updateOne(reportId, {
            sharedEvent: { t: new Date(), e: `report.${shareType}` },
            shared: [userId]
        });

        return response;
    }
}
